import { Component, OnInit } from '@angular/core';
import { environment as ENV } from '../../../environments/environment';
import {BootstrapNotifyService} from '../../services/bootstrap-notify/bootstrap-notify.service';
import {UserService} from '../../services/apiCalls/userService/user.service';
import {IResponse} from '../../interfaces/iresponse';
import {NavigatorService} from '../../services/navigatorService/navigator.service';
import * as JWT_DECODE from 'jwt-decode';
import {CacheService} from '../../services/cacheService/cache.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from "../../services/authService/auth.service";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})


export class RegisterComponent implements OnInit {
  public EMAIL_VALIDATION: any =  ENV.EMAIL_VALIDATION;
  public agentSignUp = {
    email: null,
    password: null,
    first_name: null,
    last_name: null,
    middle_name: null,
    lga_id: null,
    password_confirmation: null,
    phone_no: null,
    super_agent_code: null
  };
  public userDetails: any;
  loaders = {
    login: false,
    showResetLink: false
  };
  public allStates: any[] = [];
  public allLGA: any[] = [];
  constructor(private bootstrapNotify: BootstrapNotifyService,
              private userService: UserService,
              private cacheService: CacheService,
              private navigateService: NavigatorService,
              private router: Router,
              private authService: AuthService,
              private activeRoute: ActivatedRoute) {
    this.authService.logOut();
  }
  ngOnInit(): void {
    this.userDetails = null;
    this.getStates();
  }
  public signupAgent() {
    this.loaders.login = true;
    this.cacheService.deleteSession(ENV.TOKEN);
    this.cacheService.deleteStorage(ENV.TOKEN);
    if (!this.agentSignUp.email) {
      this.bootstrapNotify.info('Agent Email is Required');
      this.loaders.login = false;
    } else if (!this.agentSignUp.phone_no) {
      this.bootstrapNotify.info('Agent Phone Number is Required');
      this.loaders.login = false;
    } else if (!this.agentSignUp.first_name) {
      this.bootstrapNotify.info('Agent First Name is Required');
      this.loaders.login = false;
    } else if (!this.agentSignUp.last_name) {
      this.bootstrapNotify.info('Agent Last Name is Required');
      this.loaders.login = false;
    } else if (!this.agentSignUp.password) {
      this.bootstrapNotify.info('Enter a secure password');
      this.loaders.login = false;
    }  else if (this.agentSignUp.password !== this.agentSignUp.password_confirmation) {
      this.bootstrapNotify.info('Password must match!');
      this.loaders.login = false;
    } else if (!this.agentSignUp.lga_id || this.agentSignUp.lga_id === 'undefined') {
      this.bootstrapNotify.info('Select your local government!');
      this.loaders.login = false;
    } else if (!this.agentSignUp.super_agent_code ) {
      this.bootstrapNotify.info('Super Agent Code is Required!');
      this.loaders.login = false;
    } else {
      this.userService.createAgent(this.agentSignUp).subscribe((response: IResponse) => {
        this.loaders.login = false;
        this.resetSignup();
        this.navigateService.navigateUrl(`/login`);
        this.bootstrapNotify.success('Registration successful, please login');
      }, error => {
        this.bootstrapNotify.error(error.error.message || 'Unable to register at this moment, please try again', 'right');
        this.loaders.login = false;
        console.info('Error => ', error);
      });
    }
  }
  public movePage(action, position, e) {
    e.preventDefault();
    $('.step-').addClass('d-none');
    $('.step-' + position).removeClass('d-none');
/*
    if(action === 'f') {
      $('.step-' + position).removeClass('d-none');
    } else {
      $('.step-' + position).removeClass('d-none');
    }*/
  }
  public resetSignup() {
    this.agentSignUp = {
      email: null,
      password: null,
      first_name: null,
      last_name: null,
      middle_name: null,
      lga_id: null,
      password_confirmation: null,
      phone_no: null,
      super_agent_code: null
    };
  }
  public getStates() {
    this.userService.getAllState().subscribe(res => {
      console.log('Resp ', res);
      this.allStates = res.data;
    }, error => {
      console.log('Error ', error);
    })
  }
  public filterLGA(e) {
    console.log('Event ', e);
    this.allLGA = e.lgas;
  }
}
